export default __webpack_public_path__ + "static/media/bg9.7df8784f.jpg";